<template>
    <div class="relative size-full font-sans">
        <slot />
    </div>
</template>

<script lang="ts" setup></script>
